<template>
    <div class="operation_box">
        <div class="operation_item">
            <el-dropdown split-button type="primary"
                         @click="editKey"
                         @command="(command) => command()"
            >
                <i class="fa fa-pencil"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="editKey">
                        <i class="fa fa-pencil"></i>
                        {{ $t("common.edit")}}
                    </el-dropdown-item>
                    <el-dropdown-item :command="deleteKey">
                        <i class="fa fa-trash-o"></i>
                        {{ $t("common.delete")}}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
        editKey() {
            this.params.editKey(this.params.data);
        },
        deleteKey() {
            this.params.deleteKey(this.params.data);
        }
    }
};
</script>